function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2557",
  "data-name": "Group 2557",
  transform: "translate(-48.447 -35.142)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2556",
  "data-name": "Group 2556",
  transform: "translate(59.539 63.956)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3610",
  "data-name": "Path 3610",
  d: "M99.07,109.782s-1.722,11.461.346,13.718",
  transform: "translate(-69.508 -79.004)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3611",
  "data-name": "Path 3611",
  d: "M69.062,123.539c2.044-3.557,0-14.51,0-14.51",
  transform: "translate(-63.472 -78.849)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3612",
  "data-name": "Path 3612",
  d: "M97.66,82.653a71.894,71.894,0,0,1-2.685,11.486,50.606,50.606,0,0,1-3.388,7.671c-3.2,5.834-7.334,8.626-11.822,8.626-4.626,0-8.9-3.1-12.15-9.224A56.65,56.65,0,0,1,64.686,94.6a75.979,75.979,0,0,1-2.662-11.1A34.672,34.672,0,0,0,83.848,71.031,34,34,0,0,0,97.66,82.653Z",
  transform: "translate(-62.024 -71.031)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3613",
  "data-name": "Path 3613",
  d: "M62.2,89.808A24.591,24.591,0,0,1,52.8,80.847a19.875,19.875,0,0,1-2.85-10.223c0-8.423,5.345-15.756,13.312-19.721.017-.016.049-.016.065-.031A30.286,30.286,0,0,1,75.739,47.78c.414-.029.814-.029,1.214-.029a30.429,30.429,0,0,1,11.538,2.2c.716.277,1.421.584,2.094.922a.4.4,0,0,1,.112.063c7.967,3.966,13.3,11.3,13.3,19.69a20.18,20.18,0,0,1-3.329,11.006,24.693,24.693,0,0,1-8.174,7.715",
  transform: "translate(0 -2.286)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3616",
  "data-name": "Path 3616",
  d: "M93.61,90.831a1.577,1.577,0,1,0-1.574,1.513A1.547,1.547,0,0,0,93.61,90.831Z",
  transform: "translate(-8.335 -10.838)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3617",
  "data-name": "Path 3617",
  d: "M77.473,90.831A1.577,1.577,0,1,0,75.9,92.344,1.547,1.547,0,0,0,77.473,90.831Z",
  transform: "translate(-5.015 -10.838)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_556",
  "data-name": "Line 556",
  x2: 3.153,
  transform: "translate(75.714 94.95)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3618",
  "data-name": "Path 3618",
  d: "M70.277,90.3c.644-.845,2.142-1.693,4.784-1.693s3.9.712,4.787,1.693",
  transform: "translate(-4.183 -10.693)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3619",
  "data-name": "Path 3619",
  d: "M86.418,90.3c.647-.845,2.141-1.693,4.785-1.693s3.893.712,4.785,1.693",
  transform: "translate(-7.504 -10.693)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_151",
  "data-name": "Ellipse 151",
  cx: 0.6,
  cy: 0.576,
  rx: 0.6,
  ry: 0.576,
  transform: "translate(87.067 87.513)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_152",
  "data-name": "Ellipse 152",
  cx: 0.599,
  cy: 0.577,
  rx: 0.599,
  ry: 0.577,
  transform: "translate(83.901 89.947)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_153",
  "data-name": "Ellipse 153",
  cx: 0.599,
  cy: 0.577,
  rx: 0.599,
  ry: 0.577,
  transform: "translate(66.675 90.044)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_154",
  "data-name": "Ellipse 154",
  cx: 0.598,
  cy: 0.576,
  rx: 0.598,
  ry: 0.576,
  transform: "translate(71.158 90.976)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3620",
  "data-name": "Path 3620",
  d: "M92.132,111.089a.6.6,0,1,1-.6-.577A.585.585,0,0,1,92.132,111.089Z",
  transform: "translate(-8.433 -15.199)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3621",
  "data-name": "Path 3621",
  d: "M70.878,99.778a.6.6,0,1,1-.6-.577A.59.59,0,0,1,70.878,99.778Z",
  transform: "translate(-4.06 -12.871)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3622",
  "data-name": "Path 3622",
  d: "M82.6,63.71c-1.091,1.228-3.079,1.424-4.606,1.824a42.488,42.488,0,0,0-8.293,2.6,14.057,14.057,0,0,0-6.51,7.12",
  transform: "translate(-2.725 -5.569)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3623",
  "data-name": "Path 3623",
  d: "M66.772,48.586c-.016.015-.048.015-.065.031a13.844,13.844,0,0,1,27.439.032.4.4,0,0,0-.112-.063c-.674-.338-1.377-.645-2.094-.922",
  transform: "translate(-3.448)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

var SvgDarkspotsIcon = function SvgDarkspotsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57.046,
    height: 75.552,
    viewBox: "0 0 57.046 75.552",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarkspotsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/darkspots-icon.e64ea597.svg";
export { ForwardRef as ReactComponent };